export const cssQuizData = [
  {
    module: "Module 1: Introduction to CSS",
    questions: [
      {
        id: "css-q1-1",
        question: "What does CSS stand for?",
        options: [
          "Cascading Style Sheets",
          "Creative Style Sheets",
          "Computer Style Sheets",
          "Colorful Style Sheets"
        ],
        answer: "Cascading Style Sheets"
      },
      {
        id: "css-q1-2",
        question: "Why should structural information be kept in HTML rather than CSS?",
        options: [
          "Because CSS files load slower than HTML files.",
          "Because screen readers primarily read the HTML Document Object Model, ignoring content generated visually by CSS.",
          "Because CSS cannot be minified easily.",
          "Because JavaScript can only interact with HTML."
        ],
        answer: "Because screen readers primarily read the HTML Document Object Model, ignoring content generated visually by CSS."
      }
    ]
  },
  {
    module: "Module 2: Colors, Contrast & Readability",
    questions: [
      {
        id: "css-q2-1",
        question: "What is the minimum WCAG 2.1 AA contrast ratio required for normal body text against its background?",
        options: [
          "2.5:1",
          "3.0:1",
          "4.5:1",
          "7.0:1"
        ],
        answer: "4.5:1"
      },
      {
        id: "css-q2-2",
        question: "Why shouldn't color be the ONLY visual means of conveying information (like an error state)?",
        options: [
          "It uses up too much bandwidth.",
          "Users who are color blind or have low vision may not be able to perceive the color change.",
          "It causes issues on mobile devices.",
          "Browsers cache colors too strongly."
        ],
        answer: "Users who are color blind or have low vision may not be able to perceive the color change."
      }
    ]
  },
  {
    module: "Module 3: Typography & Readable Text",
    questions: [
      {
        id: "css-q3-1",
        question: "Which unit is recommended for defining font sizes to ensure users can scale text properly via browser settings?",
        options: [
          "px",
          "pt",
          "rem or em",
          "vh"
        ],
        answer: "rem or em"
      },
      {
        id: "css-q3-2",
        question: "To improve readability for dyslexic users, what is the generally recommended CSS line-height ratio?",
        options: [
          "1.0 (no gap)",
          "At least 1.5 times the font size",
          "Exactly 2.0 (double spacing)",
          "0.8 (compressed)"
        ],
        answer: "At least 1.5 times the font size"
      }
    ]
  },
  {
    module: "Module 4: Box Model & Layout Basics",
    questions: [
      {
        id: "css-q4-1",
        question: "What does the CSS Box Model consist of?",
        options: [
          "Top, Right, Bottom, Left",
          "Colors, Fonts, Layouts, Media Queries",
          "Margins, Borders, Padding, and the actual Content",
          "Header, Nav, Main, Footer"
        ],
        answer: "Margins, Borders, Padding, and the actual Content"
      },
      {
        id: "css-q4-2",
        question: "When applying `box-sizing: border-box;`, what does this do?",
        options: [
          "It adds a thick black border to every element.",
          "It forces the element width to include padding and borders, preventing accidental horizontal scrolling.",
          "It strips away all styling and returns the box to default HTML state.",
          "It generates a focus outline around the element."
        ],
        answer: "It forces the element width to include padding and borders, preventing accidental horizontal scrolling."
      }
    ]
  },
  {
    module: "Module 5: Flexbox for Accessible Layouts",
    questions: [
      {
        id: "css-q5-1",
        question: "What is the risk of using `flex-direction: row-reverse;` heavily in layouts?",
        options: [
          "It causes the browser to render much slower.",
          "It breaks the visual sequence away from the underlying DOM order, confusing keyboard navigation users.",
          "It stops CSS animations from working.",
          "It breaks compatibility with older cell phones."
        ],
        answer: "It breaks the visual sequence away from the underlying DOM order, confusing keyboard navigation users."
      },
      {
        id: "css-q5-2",
        question: "Which CSS flex property controls alignment along the main axis?",
        options: [
          "align-items",
          "flex-wrap",
          "justify-content",
          "align-content"
        ],
        answer: "justify-content"
      }
    ]
  },
  {
    module: "Module 6: CSS Grid & Responsive Design",
    questions: [
      {
        id: "css-q6-1",
        question: "Why is responsive styling (like media queries) considered an accessibility requirement?",
        options: [
          "It makes the code look cleaner.",
          "It ensures users who zoom their browser by 200% or 400% can still read content without horizontal scrolling.",
          "It forces the website into dark mode automatically.",
          "Search engines demand it."
        ],
        answer: "It ensures users who zoom their browser by 200% or 400% can still read content without horizontal scrolling."
      },
      {
        id: "css-q6-2",
        question: "What CSS Grid property allows columns to automatically wrap natively without media queries?",
        options: [
          "grid-template-areas",
          "auto-fit / auto-fill",
          "grid-column-gap",
          "justify-items"
        ],
        answer: "auto-fit / auto-fill"
      }
    ]
  },
  {
    module: "Module 7: Focus Styles & Keyboard Visibility",
    questions: [
      {
        id: "css-q7-1",
        question: "Why is setting `outline: none;` without providing a fallback focus style harmful?",
        options: [
          "It crashes the styling completely.",
          "It makes the page render out of bounds.",
          "It renders keyboard navigation invisible, leaving users unable to know which element is currently targeted.",
          "It invalidates the HTML syntax."
        ],
        answer: "It renders keyboard navigation invisible, leaving users unable to know which element is currently targeted."
      },
      {
        id: "css-q7-2",
        question: "What is the `:focus-visible` pseudo-class designed to do?",
        options: [
          "Show focus rings only when a screen reader is active.",
          "Show focus rings only when a user is navigating via keyboard, rather than causing focus rings on mouse clicks.",
          "Add heavy borders to every div on the page.",
          "Always highlight elements randomly."
        ],
        answer: "Show focus rings only when a user is navigating via keyboard, rather than causing focus rings on mouse clicks."
      }
    ]
  },
  {
    module: "Module 8: Animations & Reduced Motion",
    questions: [
      {
        id: "css-q8-1",
        question: "Why should aggressive parallax scrolling and flashing animations be avoided or controllable?",
        options: [
          "They take up too much memory on iPads.",
          "They can trigger vestibular disorders, nausea, and seizures in sensitive users.",
          "They make the codebase too large.",
          "They prevent Google from indexing the site."
        ],
        answer: "They can trigger vestibular disorders, nausea, and seizures in sensitive users."
      },
      {
        id: "css-q8-2",
        question: "Which CSS media query checks if a user has requested less animation in their OS settings?",
        options: [
          "@media (prefers-static-display)",
          "@media (prefers-reduced-motion: reduce)",
          "@media (no-animations)",
          "@media (disable-css-motion)"
        ],
        answer: "@media (prefers-reduced-motion: reduce)"
      }
    ]
  },
  {
    module: "Module 9: CSS for Screen Reader Content",
    questions: [
      {
        id: "css-q9-1",
        question: "If you apply `display: none;` to a block of text, what does a screen reader do?",
        options: [
          "It reads the text extremely loudly.",
          "It completely ignores the text as if it doesn't exist.",
          "It pauses for 5 seconds.",
          "It skips the text but says 'Hidden'."
        ],
        answer: "It completely ignores the text as if it doesn't exist."
      },
      {
        id: "css-q9-2",
        question: "What is the generally accepted pattern (often known as 'sr-only') used to visually hide text while allowing screen readers to STILL read it?",
        options: [
          "Setting color: transparent",
          "Setting opacity: 0",
          "Positioning it absolutely off-screen with 1px dimensions and clipped borders",
          "Applying display: block and visibility: hidden"
        ],
        answer: "Positioning it absolutely off-screen with 1px dimensions and clipped borders"
      }
    ]
  },
  {
    module: "Module 10: Building an Accessible Portfolio",
    questions: [
      {
        id: "css-q10-1",
        question: "When creating a web portfolio, how do you verify your color palette provides enough contrast?",
        options: [
          "Squint your eyes.",
          "Run the design through a WCAG algorithmic contrast checking tool.",
          "Make everything black and white exclusively.",
          "Consult a mood ring."
        ],
        answer: "Run the design through a WCAG algorithmic contrast checking tool."
      },
      {
        id: "css-q10-2",
        question: "A skip-link (`Skip to main content`) should behave exactly how visually?",
        options: [
          "It should be entirely invisible permanently.",
          "It should be visible entirely at the bottom of the page.",
          "It can be visually hidden by default, but MUST visibly appear on the screen when it receives keyboard focus.",
          "It should flash neon colors continuously."
        ],
        answer: "It can be visually hidden by default, but MUST visibly appear on the screen when it receives keyboard focus."
      }
    ]
  }
];
